export const I18N = {
    de: {
        backTitle: 'Zurück',
        nextTitle: 'Weiter',
        pageSize: {
            5: '5 pro Seite',
            10: '10 pro Seite',
            50: '50 pro Seite',
            100: '100 pro Seite'
        }


    },
    en: {
        backTitle: 'Back',
        nextTitle: 'Next',
        pageSize: {
            5: '5 per page',
            10: '10 per page',
            50: '50 per page',
            100: '100 per page'
        }
    }
};
